import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';

const styles = {
  stdCell: {
    fontSize: '12px',
    height: '45px',
    width: '54px',
    padding: 'auto',
    margin: '-1px',
    borderTopWidth: '2px',
    borderBottomWidth: '2px',
    borderRightWidth: '2px',
    borderStyle: 'solid',
    borderTopColor: 'gray',
    borderBottomColor: 'gray',
    borderRightColor: 'gray',
  },
  infoCell: {
    fontSize: '9px',
    height: '32px',
    width: '42px',
    padding: 'auto',
    margin: '-1px',
    borderTopWidth: '2px',
    borderBottomWidth: '2px',
    borderRightWidth: '2px',
    borderStyle: 'solid',
    borderTopColor: 'gray',
    borderBottomColor: 'gray',
    borderRightColor: 'gray',
  },
};

const getCellStyles = (infoCard) => {
  if (!infoCard) {
    return styles.stdCell;
  }
  return styles.infoCell;
};

function Cell({ cellId, isActive, centerLine, infoCard }) {
  const cellStyles = getCellStyles(infoCard);
  return (
    <div
      id={cellId}
      className="col"
      style={{
        ...cellStyles,
        background: isActive[cellId] ? '#5cbfe6' : '',
        borderLeftColor: centerLine ? 'black' : 'gray',
        borderLeftWidth: centerLine ? '6px' : '2px',
      }}
    />
  );
}

function Grid({ cells = {}, handleAnswer, timedOut, infoCard = false, centerLine = false }) {
  const [answered, setAnswered] = useState(false);

  return (
    <div>
      <div className="col m-3 user-select-none">
        <div className="row">
          <Cell cellId={1} isActive={cells} infoCard={infoCard} />
          <Cell cellId={2} isActive={cells} infoCard={infoCard} />
          <Cell cellId={3} isActive={cells} infoCard={infoCard} />
          <Cell cellId={4} isActive={cells} infoCard={infoCard} />
          <Cell cellId={5} isActive={cells} centerLine={centerLine} infoCard={infoCard} />
          <Cell cellId={6} isActive={cells} infoCard={infoCard} />
          <Cell cellId={7} isActive={cells} infoCard={infoCard} />
          <Cell cellId={8} isActive={cells} infoCard={infoCard} />
        </div>
        <div className="row">
          <Cell cellId={9} isActive={cells} infoCard={infoCard} />
          <Cell cellId={10} isActive={cells} infoCard={infoCard} />
          <Cell cellId={11} isActive={cells} infoCard={infoCard} />
          <Cell cellId={12} isActive={cells} infoCard={infoCard} />
          <Cell cellId={13} isActive={cells} centerLine={centerLine} infoCard={infoCard} />
          <Cell cellId={14} isActive={cells} infoCard={infoCard} />
          <Cell cellId={15} isActive={cells} infoCard={infoCard} />
          <Cell cellId={16} isActive={cells} infoCard={infoCard} />
        </div>
        <div className="row">
          <Cell cellId={17} isActive={cells} infoCard={infoCard} />
          <Cell cellId={18} isActive={cells} infoCard={infoCard} />
          <Cell cellId={19} isActive={cells} infoCard={infoCard} />
          <Cell cellId={20} isActive={cells} infoCard={infoCard} />
          <Cell cellId={21} isActive={cells} centerLine={centerLine} infoCard={infoCard} />
          <Cell cellId={22} isActive={cells} infoCard={infoCard} />
          <Cell cellId={23} isActive={cells} infoCard={infoCard} />
          <Cell cellId={24} isActive={cells} infoCard={infoCard} />
        </div>
        <div className="row">
          <Cell cellId={25} isActive={cells} infoCard={infoCard} />
          <Cell cellId={26} isActive={cells} infoCard={infoCard} />
          <Cell cellId={27} isActive={cells} infoCard={infoCard} />
          <Cell cellId={28} isActive={cells} infoCard={infoCard} />
          <Cell cellId={29} isActive={cells} centerLine={centerLine} infoCard={infoCard} />
          <Cell cellId={30} isActive={cells} infoCard={infoCard} />
          <Cell cellId={31} isActive={cells} infoCard={infoCard} />
          <Cell cellId={32} isActive={cells} infoCard={infoCard} />
        </div>
        <div className="row">
          <Cell cellId={33} isActive={cells} infoCard={infoCard} />
          <Cell cellId={34} isActive={cells} infoCard={infoCard} />
          <Cell cellId={35} isActive={cells} infoCard={infoCard} />
          <Cell cellId={36} isActive={cells} infoCard={infoCard} />
          <Cell cellId={37} isActive={cells} centerLine={centerLine} infoCard={infoCard} />
          <Cell cellId={38} isActive={cells} infoCard={infoCard} />
          <Cell cellId={39} isActive={cells} infoCard={infoCard} />
          <Cell cellId={40} isActive={cells} infoCard={infoCard} />
        </div>
        <div className="row">
          <Cell cellId={41} isActive={cells} infoCard={infoCard} />
          <Cell cellId={42} isActive={cells} infoCard={infoCard} />
          <Cell cellId={43} isActive={cells} infoCard={infoCard} />
          <Cell cellId={44} isActive={cells} infoCard={infoCard} />
          <Cell cellId={45} isActive={cells} centerLine={centerLine} infoCard={infoCard} />
          <Cell cellId={46} isActive={cells} infoCard={infoCard} />
          <Cell cellId={47} isActive={cells} infoCard={infoCard} />
          <Cell cellId={48} isActive={cells} infoCard={infoCard} />
        </div>
        <div className="row">
          <Cell cellId={49} isActive={cells} infoCard={infoCard} />
          <Cell cellId={50} isActive={cells} infoCard={infoCard} />
          <Cell cellId={51} isActive={cells} infoCard={infoCard} />
          <Cell cellId={52} isActive={cells} infoCard={infoCard} />
          <Cell cellId={53} isActive={cells} centerLine={centerLine} infoCard={infoCard} />
          <Cell cellId={54} isActive={cells} infoCard={infoCard} />
          <Cell cellId={55} isActive={cells} infoCard={infoCard} />
          <Cell cellId={56} isActive={cells} infoCard={infoCard} />
        </div>
        <div className="row">
          <Cell cellId={57} isActive={cells} infoCard={infoCard} />
          <Cell cellId={58} isActive={cells} infoCard={infoCard} />
          <Cell cellId={59} isActive={cells} infoCard={infoCard} />
          <Cell cellId={60} isActive={cells} infoCard={infoCard} />
          <Cell cellId={61} isActive={cells} centerLine={centerLine} infoCard={infoCard} />
          <Cell cellId={62} isActive={cells} infoCard={infoCard} />
          <Cell cellId={63} isActive={cells} infoCard={infoCard} />
          <Cell cellId={64} isActive={cells} infoCard={infoCard} />
        </div>
      </div>

      {handleAnswer && !answered && !timedOut && (
        <div className="d-flex justify-content-center">
          <Button
            className="btn-assessment-primary mx-2"
            onClick={() => {
              setAnswered(true);
              handleAnswer(true);
            }}
          >
            True
          </Button>
          <Button
            className="btn-assessment-primary mx-2"
            onClick={() => {
              setAnswered(true);
              handleAnswer(false);
            }}
          >
            False
          </Button>
        </div>
      )}
    </div>
  );
}

export default Grid;
